import { useState, useRef } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ManifiestoSection from './components/ManifiestoSection';
import CartografiaSection from './components/CartografiaSection';
import ResonanciaSection from './components/ResonanciaSection';
import PlanesSection from './components/PlanesSection';
import IniciarTrazadoSection from './components/IniciarTrazadoSection';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';

export default function HomePage() {
  const [loginOpen, setLoginOpen] = useState(false);
  const registerRef = useRef<HTMLElement | null>(null);

  const handleGoToRegister = () => {
    setLoginOpen(false);
    setTimeout(() => {
      const el = document.querySelector('#iniciar-trazado');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 200);
  };

  return (
    <div className="min-h-screen font-jost">
      <Navbar onOpenLogin={() => setLoginOpen(true)} />
      <main ref={registerRef as React.RefObject<HTMLElement>}>
        <HeroSection />
        <ManifiestoSection />
        <CartografiaSection />
        <ResonanciaSection />
        <PlanesSection />
        <IniciarTrazadoSection openLoginModal={() => setLoginOpen(true)} />
      </main>
      <Footer />
      <AuthModal
        isOpen={loginOpen}
        onClose={() => setLoginOpen(false)}
        onGoToRegister={handleGoToRegister}
      />
    </div>
  );
}
